// @flow
import * as React from 'react';
import { getAuctioneerDirectoryUrl, getAuctionResultsUrl } from '../../../utils/urls';
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components4/lib/Link/Link';
import styles from './LACrown.module.scss';

type Props = {
    baseUrl: string,
    classicBaseUrl: string,
    pathname: string,
};

const classicLink = (classicBaseUrl: string, pathname: string) => {
    if (pathname.includes('/auctioneer/') && pathname.endsWith('past/')) {
        return `${classicBaseUrl}${pathname.replace('past/', '')}`;
    }

    if (pathname.includes('auction-results')) {
        return `${classicBaseUrl}/search?dtype=gallery&hasimage=true&type=complete`;
    }
    return `${classicBaseUrl}${pathname}`;
};

const LACrown = (props: Props) => {
    const { baseUrl, classicBaseUrl, pathname } = props;

    return (
        <div className={styles.crown}>
            <div className={styles['crown-inner']}>
                <Link route to={getAuctioneerDirectoryUrl()} secondary>
                    <FormattedMessage id="directory" />
                </Link>
                <Link route to={getAuctionResultsUrl()} secondary>
                    <FormattedMessage id="price_results" />
                </Link>
                <Link target="_blank" to={`${baseUrl}/news/`} secondary>
                    <FormattedMessage id="news" />
                </Link>
                <Link target="_blank" to="https://help.liveauctioneers.com/" secondary rel="noopener">
                    <FormattedMessage id="help" />
                </Link>
                <Link route to="/consignments" secondary>
                    <FormattedMessage id="consign" />
                </Link>
                <span>|</span>
                <Link to={classicLink(classicBaseUrl, pathname)} secondary rel="nofollow">
                    <FormattedMessage id="classic_site" />
                </Link>
            </div>
        </div>
    );
};

export default React.memo<Props>(LACrown);
